module.exports = __webpack_public_path__ + "img/xiaoben.5ba97857.png";